import { render, staticRenderFns } from "./questionTypeText.vue?vue&type=template&id=93b9ed78&scoped=true&"
import script from "./questionTypeText.vue?vue&type=script&lang=js&"
export * from "./questionTypeText.vue?vue&type=script&lang=js&"
import style0 from "./questionTypeText.vue?vue&type=style&index=0&id=93b9ed78&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b9ed78",
  null
  
)

export default component.exports